// extracted by mini-css-extract-plugin
module.exports = {"container":"az_Ohc","leftImageContainer":"az_Phc","rightImageContainer":"az_Qhc","image":"az_Rhc","copyContainer":"az_Shc","installCopy":"az_Thc","seeAllCopy":"az_Uhc"};